import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { ArrowDown, Cancel } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";

export const MultiSelectionDropdown = ({ options, placeholder, value = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const {t} = useTranslation()
  const dropdownRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle selection toggle
  const handleSelect = (option) => {
    const newValue = value.includes(option.value)
      ? value.filter((val) => val !== option.value) // Remove if already selected
      : [...value, option.value]; // Add if not selected
    onChange(newValue);
  };

  // Handle removing selected item
  const removeSelected = (optionValue) => {
    onChange(value.filter((val) => val !== optionValue));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter options based on search input
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <DropdownWrapper ref={dropdownRef}>
      {/* Selected Items Field */}
      <DropdownField onClick={toggleDropdown}>
        {value.length > 0 ? (
          <SelectedItems>
            {options
              .filter((opt) => value.includes(opt.value))
              .map((opt) => (
                <SelectedItem key={opt.value}>
                  {t(opt.label)}
                  <Cancel width={12} height={12} onClick={() => removeSelected(opt.value)} />
                </SelectedItem>
              ))}
          </SelectedItems>
        ) : (
          <Placeholder>{placeholder}</Placeholder>
        )}
        <ArrowDown isOpen={isOpen} />
      </DropdownField>

      {/* Dropdown List */}
      {isOpen && (
        <DropdownList>
          {/* Search Input */}
          <SearchInput
            type="text"
            placeholder={t("search")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()} // Prevent closing dropdown on input click
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <DropdownItem
                key={option.value}
                selected={value.includes(option.value)}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </DropdownItem>
            ))
          ) : (
            <NoOptions>No options found</NoOptions>
          )}
        </DropdownList>
      )}
    </DropdownWrapper>
  );
};

// Styled Components
const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownField = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 48px;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg);
  cursor: pointer;
`;

const Placeholder = styled.span`
  color: var(--textPlaceholder);
`;

const SelectedItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const SelectedItem = styled.div`
  background: var(--border);
  color: black;
  padding: 4px 8px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;

  svg {
    cursor: pointer;
  }
`;

const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid var(--border);
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

const DropdownItem = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? "var(--border)" : "white")};
  font-weight: ${({ selected }) => (selected ? "bold" : "normal")};
  color: ${({ selected }) => (selected ? "var(--themeColor)" : "black")};

  &:hover {
    background: var(--border);
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  border: none;
  border-bottom: 1px solid var(--border);
  outline: none;
  font-size: 14px;
  color: black; /* Ensure text color is black */
  background: white;
`;

const NoOptions = styled.div`
  padding: 10px;
  text-align: center;
  color: gray;
`;




// import React, { useState, useRef, useEffect } from "react";
// import styled from "styled-components";
// import { ArrowDown, Cancel } from "../../styled/AllImages";

// export const MultiSelectionDropdown = ({ options, placeholder, value = [], onChange }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Toggle dropdown open/close
//   const toggleDropdown = () => setIsOpen(!isOpen);

//   // Handle selection toggle
//   const handleSelect = (option) => {
//     const newValue = value.includes(option.value)
//       ? value.filter((val) => val !== option.value) // Remove if already selected
//       : [...value, option.value]; // Add if not selected
//     onChange(newValue);
//   };

//   // Handle removing selected item
//   const removeSelected = (optionValue) => {
//     onChange(value.filter((val) => val !== optionValue));
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <DropdownWrapper ref={dropdownRef}>
//       {/* Selected Items Field */}
//       <DropdownField onClick={toggleDropdown}>
//         {value.length > 0 ? (
//           <SelectedItems>
//             {options
//               .filter((opt) => value.includes(opt.value))
//               .map((opt) => (
//                 <SelectedItem key={opt.value}>
//                   {opt.label}
//                   <Cancel width={12} height={12} onClick={() => removeSelected(opt.value)} />
//                 </SelectedItem>
//               ))}
//           </SelectedItems>
//         ) : (
//           <Placeholder>{placeholder}</Placeholder>
//         )}
//         <ArrowDown isOpen={isOpen} />
//       </DropdownField>

//       {/* Dropdown List */}
//       {isOpen && (
//         <DropdownList>
//           {options.map((option) => (
//             <DropdownItem
//               key={option.value}
//               selected={value.includes(option.value)}
//               onClick={() => handleSelect(option)}
//             >
//               {option.label}
//             </DropdownItem>
//           ))}
//         </DropdownList>
//       )}
//     </DropdownWrapper>
//   );
// };

// // Styled Components
// const DropdownWrapper = styled.div`
//   position: relative;
//   width: 100%;
// `;

// const DropdownField = styled.div`
//   display: flex;
//   align-items: center;
//   flex-wrap: wrap;
//   min-height: 48px;
//   padding: 8px 12px;
//   border: 1px solid var(--border);
//   border-radius: 8px;
//   background: var(--bg);
//   cursor: pointer;
// `;

// const Placeholder = styled.span`
//   color: var(--textPlaceholder);
// `;

// const SelectedItems = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 6px;
// `;

// const SelectedItem = styled.div`
//   background: var(--border);
//   color: black;
//   padding: 4px 8px;
//   border-radius: 16px;
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   font-size: 14px;

//   svg {
//     cursor: pointer;
//   }
// `;

// // const ArrowIcon = styled(IoIosArrowDown)`
// //   margin-left: auto;
// //   transition: transform 0.3s;
// //   transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0)")};
// // `;

// const DropdownList = styled.div`
//   position: absolute;
//   top: 100%;
//   left: 0;
//   right: 0;
//   background: white;
//   border: 1px solid var(--border);
//   border-radius: 8px;
//   max-height: 200px;
//   overflow-y: auto;
//   z-index: 100;
//   box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
// `;

// const DropdownItem = styled.div`
//   padding: 10px 12px;
//   cursor: pointer;
//   background: ${({ selected }) => (selected ? "var(--border)" : "white")};
//   font-weight: ${({ selected }) => (selected ? "bold" : "normal")};
//   color: ${({ selected }) => (selected ? "var(--themeColor)" : "black")};

//   &:hover {
//     background: var(--border);
//   }
// `;
